import {h, Component} from 'preact';
import {connect} from 'react-redux';
import reduce from '../reducers';
import * as actions from '../actions';
import util from '../util';
import constants from '../constants';

import Renderer from '../canvas/renderer';

import FlipWidget from './FlipWidget';
import PositionTools from './PositionTools';
import ResizeWidget from './ResizeWidget';
import ImageBorderWidget from "./ImageBorderWidget";
import GroupBarListItem from "./GroupBarListItem";
import { UnlockOutlined, LockOutlined, DeleteOutlined } from "@ant-design/icons";
import {canDisplayAlign} from "../canvas/component";

export default @connect(reduce, actions)
class ImageBar extends Component {
  constructor() {
    super();

    this.state = {
      borderColor: '000000'
    };

    this.ungroup = () => {
      Renderer.ungroup(this.props.$element);
    };

    this.copyElement = () => {
      const $copy = Renderer.copy(this.props.isMultiSelect ? this.props.$elements : this.props.$element);
      $copy.click();
    };

    this.copyGroup = () => {
      Renderer.copy(this.props.$element.parents('.group'));
    };

    this.fixImagePath = () => {
      const path = Renderer.getImagePath(this.props.$element);
      this.props.showFixImageModal(path);
    };

    this.removeElement = () => {
      this.props.deselect();
      Renderer.remove(this.props.isMultiSelect ? this.props.$elements : this.props.$element, this.props.isMultiSelect);
    };

    this.removeGroup = () => {
      this.props.deselect();
      Renderer.remove(this.props.$element.parents('.group'));
    };

    this.updateBorderRadius = (ev) => {
      const val = ev.target.value;
      const $img = this.props.$element.find('img');

      Renderer.updateElementStyle($img, 'borderRadius', val / 10 + 'em');
      $img.attr('data-border-radius', val);
      this.props.updateElementAttribute('borderRadius', val);
    };

    this.updateOpacity = (ev) => {
      const val = ev.target.value;
      const $elem = util.getElementContent(this.props.$element);

      Renderer.updateElementStyle($elem, 'opacity', val / 100);
      this.props.updateElementAttribute('opacity', val);
    };

    this.updateBorderWidth = (ev) => {
      const val = ev.target.value;
      const $img = this.props.$element.find('img');

      Renderer.updateElementStyle($img, 'borderWidth', val / 10 + 'em');
      $img.attr('data-border-width', val);
      if (val > 0) Renderer.updateElementStyle($img, 'borderStyle', 'solid');
      this.props.updateElementAttribute('borderWidth', val);
    };

    this.initializePicker = () => {
      if (!!this.refs) {
        ColorPicker(this.refs.picker, (hex, hsv, rgb) => {
          this.changeBorderColor(hex);
          this.setState({'borderColor': hex.slice(1)})
        })
      }
    };

    this.changeBorderColor = (color) => {
      Renderer.updateElementStyle(this.props.$element.find('img'), 'borderColor', color);
      this.props.updateElementAttribute('borderColor', color);
    };

    this.clearBorder = () => {
      Renderer.updateElementStyle(this.props.$element.find('.img'), 'borderColor', constants.DEFAULT_TEXT_COLOR);
      Renderer.updateElementStyle(this.props.$element.find('.img'), 'borderWidth', 0);
      this.props.updateElementAttribute('borderWidth', '0');
      this.props.updateElementAttribute('borderColor', constants.DEFAULT_TEXT_COLOR);
    };

    this.toggleLock = () => {
      const $elements = this.props.isMultiSelect ? this.props.$elements : this.props.$element;
      if (this.props.isLocked) {
        Renderer.unlock($elements);
      } else {
        Renderer.lock($elements);
      }
      this.props.updateElementAttribute('isLocked', !this.props.isLocked);
    }

    this.openColorPicker = () => {
      util.openColorPicker(constants.pickerTypes.imageBorder);
    }
  }

  componentDidMount() {
    this.initializePicker();
    this.setDefaultBorderColor();
  }

  setDefaultBorderColor() {
    if (!!this.props.borderColor && this.state.borderColor !== this.props.borderColor.slice(1)) {
      this.setState({borderColor: this.props.borderColor.slice(1)});
    }
  }

  render(props, state) {
    return (
      <div className="context-bar">
        <ul>
          {props.isMobileVersion &&
          <li>
            <a className="mobile-tool-widget" data-hint="Delete" onClick={this.removeElement}>
              <DeleteOutlined />
              {props.isMobileVersion && <span>Delete</span>}
            </a>
          </li>}

          {!props.multiselect && <li>
            <ImageBorderWidget
              width={props.borderWidth}
              color={props.borderColor}
              value={props.borderRadius}
              withNoBorder={false}
              onWidthUpdate={this.updateBorderWidth}
              onColorUpdate={this.changeBorderColor}
              onClearBorder={this.clearBorder.bind(this)}
              openColorPicker={this.openColorPicker}
              $element={this.props.$element}
              updateBorderRadius={this.updateBorderRadius.bind(this)} />
          </li>}

          {!props.multiselect && !props.isMobileVersion && <span className="separator"></span>}

          {!props.multiselect && <li>
            <div className="dropdown sizes">
              <a className={`dropdown-toggle ${!props.isMobileVersion ? 'icn rwd-icon hint--bottom' : 'mobile-tool-widget'}`} data-hint="Opacity">
                <svg>
                  <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-opacity"}/>
                </svg>
                {props.isMobileVersion && <span>Opacity</span>}
              </a>
              <div className="dropdown-menu auto" data-close="no">
                <ul className="slider-list">
                  <li className="slider-item">
                    <div className={'slider-wrap'}>
                      <label>Opacity</label>
                      <div className="toolbar-wrap">
                        <input className="slider" type="range" min="0" max="100" step="1" value={props.opacity} onChange={this.updateOpacity} onMouseMove={this.updateOpacity}/>
                      </div>
                      <input className="value" type="number" min="0" max="100" step="1" disabled="disabled" value={Math.round(props.opacity)}/>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </li>}

          {!props.multiselect && <span className="separator"></span>}
          {!props.multiselect && <li>
            <FlipWidget/>
          </li>}
          {!props.multiselect && <span className="separator"></span>}
          {(props.isAdmin || props.isDesigner) && <li>
            <ResizeWidget/>
          </li>}
        </ul>

        {!props.isLocked && <ul className="secondary">
          {props.isAdmin || props.isDesigner && <li><a onClick={this.fixImagePath} className="red bold" style="display: none">Fix it</a></li>}
          <li className={!props.isInGroup ? 'hidden' : ''}>
            <a className="icn rwd-icon ungroup-btn" onClick={this.ungroup}>
              <span>Ungroup</span>
            </a>
          </li>
          {props.multiselect && <GroupBarListItem {...props} />}
          {canDisplayAlign(props.$element) && <li>
            <PositionTools/>
          </li>}
          {/*<li>
              <HyperlinkWidget $element={props.$element} href={props.href} isHyperlink={props.isHyperlink} updateElementAttribute={props.updateElementAttribute} hasPdfPermission={props.hasPdfPermission} setActiveMember={props.setActiveMember} />
          </li>*/}
          {!props.isMobileVersion && <span className="separator"></span>}
          
          <li>
            <a className={!props.isMobileVersion ? 'icn rwd-icon hint--bottom' : 'mobile-tool-widget'} data-hint="Duplicate" onClick={props.isInGroup ? this.copyGroup : this.copyElement}><span>Copy</span>
              <svg>
                <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-copy"}/>
              </svg>
              {props.isMobileVersion && <span>Copy</span>}
            </a>
          </li>
          <li>
            <a className={!props.isMobileVersion ? 'icn rwd-icon hint--bottom' : 'mobile-tool-widget'} data-hint="Lock" onClick={this.toggleLock}>
              <UnlockOutlined />
              {props.isMobileVersion && <span>Lock</span>}
            </a>
          </li>
          {!props.isMobileVersion &&
          <li>
            {props.isInGroup &&
            <div className="dropdown sizes">
              <a className="dropdown-toggle icn rwd-icon hint--bottom" data-hint="Delete">
                <DeleteOutlined />
              </a>
              <div className="dropdown-menu" style="right: 0; width: auto;">
                <ul className="slider-list">
                  <li>
                    <a className="hint--bottom" data-hint="Delete" onClick={this.removeElement}>Delete</a>
                  </li>
                  <li>
                    <a onClick={this.removeGroup}>Remove Group</a>
                  </li>
                </ul>
              </div>
            </div>}

            {!props.isInGroup &&
            <a className="rwd-icon hint--bottom" data-hint="Delete" onClick={this.removeElement}>
              <DeleteOutlined />
            </a>}
          </li>}
        </ul>}

        {props.isLocked &&
        <ul className="secondary">
          <li>
            <a className={!props.isMobileVersion ? 'icn tgl act rwd-icon hint--bottom' : 'act mobile-tool-widget'} data-hint="Unlock" onClick={this.toggleLock}>
              <LockOutlined />
              {props.isMobileVersion && <span>Unlock</span>}
            </a>
          </li>
          <li>
            <a className="locked-label hint--bottom" data-hint="Unlock" onClick={this.toggleLock}>Locked</a>
          </li>
        </ul>}
      </div>
    )
  }
}
